import { CommonModule, Location } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UIButton } from '../../shared/ui/button/button.component';

@Component({
  standalone: true,
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss',
  imports: [CommonModule, RouterLink, UIButton],
})
export class AccessDeniedComponent {
  constructor(private _location: Location) {}

  back(): void {
    this._location.back();
  }
}
